import { render } from "./OrchardDetailsForm.vue?vue&type=template&id=0c7e4728&ts=true"
import script from "./OrchardDetailsForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrchardDetailsForm.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Orchard/OrchardDetailsForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0c7e4728"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0c7e4728', __exports__)) {
    console.log('reload')
    api.reload('0c7e4728', __exports__)
  }
  
  module.hot.accept("./OrchardDetailsForm.vue?vue&type=template&id=0c7e4728&ts=true", () => {
    console.log('re-render')
    api.rerender('0c7e4728', render)
  })

}


export default __exports__